
import React from 'react';

export const HeroSection: React.FC = () => {
  return (
    <section
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `url('/images/adventure-hero.jpg')`
      }}
    >
      {/* Dark overlay for better text readability */}
      <div className="absolute inset-0 bg-black/50"></div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center text-white">
        <h1 className="text-5xl md:text-6xl font-bold mb-6">
          Explore African Wildlife and Adventures
        </h1>
        <div className="w-24 h-1 bg-emerald-500 mx-auto mb-6"></div>
        <p className="text-xl md:text-2xl leading-relaxed max-w-3xl mx-auto">
          Embark on extraordinary adventures across Africa's most spectacular landscapes. From thrilling safaris witnessing the Big Five to exploring ancient cultures and breathtaking natural wonders, discover the continent's incredible diversity and untamed beauty through carefully curated adventure experiences.
        </p>
      </div>
    </section>
  );
};
